export {};
//# sourceMappingURL=IParticleSystem.js.map